"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ParametersProvider_1 = require("@dialogexe/cw-parameters-provider/ParametersProvider");
function registerParameters() {
    const parameters = require('../../../parameters.json');
    const config = require('../../../config/config.json');
    ParametersProvider_1.parametersProvider.register({ ...parameters, site: config });
    return Promise.resolve(true);
}
exports.registerParameters = registerParameters;



// WEBPACK FOOTER //
// ./gatsby-builder/bootstrap/tasks/registerParameters.ts